import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mediaImageUrl',
  standalone: true,
})
export class MediaImageUrlPipe implements PipeTransform {
  constructor(@Inject('baseS3Path') private readonly baseS3Path: string) {}

  transform(mediaFileKey: string, size?: string): string {
    if (!mediaFileKey.startsWith('media/')) {
      // Handle unexpected format by returning the base path with the key
      return `${this.baseS3Path}/${mediaFileKey}`;
    }

    const parts = mediaFileKey.split('/');
    if (parts.length < 3) {
      // Handle unexpected format by returning the base path with the key
      return `${this.baseS3Path}/${mediaFileKey}`;
    }

    const [root, fileType, ...rest] = parts;
    const fileKey = rest.join('/');

    if (fileType === 'videos') {
      // Apply video thumbnail URL logic
      if (size) {
        return `${this.baseS3Path}/${mediaFileKey}/default/thumbnails/${size}/${fileKey}.0000000.jpg`;
      } else {
        return `${this.baseS3Path}/${mediaFileKey}/default/thumbnails/${fileKey}.0000000.jpg`;
      }
    } else if (fileType === 'images') {
      // Apply image URL logic with optional size
      if (size) {
        return `${this.baseS3Path}/${root}/${fileType}/${size}/${fileKey}`;
      } else {
        return `${this.baseS3Path}/${mediaFileKey}`;
      }
    } else {
      // Handle other file types if necessary
      return `${this.baseS3Path}/${mediaFileKey}`;
    }
  }
}
